import { ModuleEventAttendance } from '../models/module-event-attendance.model';

export class AddModuleEventAttendances {
    static readonly type = '[ModuleEventAttendance] AddModuleEventAttendances';

    constructor(public payload: ModuleEventAttendance[]) {}
}
